export default __webpack_public_path__ + "static/media/fall-cover-large.001e6391.png";